"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = triggerParticleExplosion;

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var getRandom = function getRandom(min, max) {
  var decimalPlaces = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return parseFloat((Math.random() * ((min || 1) - max) + max).toFixed(decimalPlaces));
};

function renderParticles(particles, particleCanvasContext, width, height) {
  requestAnimationFrame(function () {
    renderParticles(particles, particleCanvasContext, width, height);
  });
  particleCanvasContext.clearRect(0, 0, width, height);
  particles.forEach(function (particle) {
    /* eslint-disable no-param-reassign */
    particle.x += particle.speed * Math.cos(particle.rotation * Math.PI / 180);
    particle.y += particle.speed * Math.sin(particle.rotation * Math.PI / 180);
    particle.opacity -= 0.01;
    particle.speed *= particle.friction;
    particle.radius *= particle.friction;
    particle.yVel += particle.gravity;
    particle.y += particle.yVel;
    particleCanvasContext.beginPath();
    particleCanvasContext.globalAlpha = particle.opacity;
    particleCanvasContext.fillStyle = particle.color;
    particleCanvasContext.arc(particle.x, particle.y, particle.radius, 0, 2 * Math.PI, false);
    particleCanvasContext.fill();
    /* eslint-enable no-param-reassign */
  });
  return particleCanvasContext;
}

function triggerParticleExplosion(xCoord, yCoord) {
  var ratio = window.devicePixelRatio;
  var particleCanvas = document.createElement('canvas');
  var particleCanvasContext = particleCanvas.getContext('2d');
  particleCanvas.style.position = 'absolute';
  particleCanvas.style.left = "".concat(xCoord - 100, "px");
  particleCanvas.style.top = "".concat(yCoord - 100, "px");
  particleCanvas.style.pointerEvents = 'none';
  particleCanvas.style.width = "".concat(200, "px");
  particleCanvas.style.height = "".concat(200, "px");
  particleCanvas.style.zIndex = '100';
  particleCanvas.width = 300 * ratio;
  particleCanvas.height = 300 * ratio;

  if (!document.body) {
    return;
  }

  document.body.appendChild(particleCanvas);
  var height = particleCanvas.height,
      width = particleCanvas.width;

  var particles = _toConsumableArray(Array(25)).map(function () {
    return {
      x: width / 2,
      y: height / 2,
      radius: getRandom(20, 30),
      color: _vars.COLOURS.cyan.jungleGreen.monkey,
      rotation: getRandom(0, 360, 1),
      speed: getRandom(12, 16),
      friction: 0.9,
      opacity: getRandom(0, 0.5, 1),
      yVel: 0,
      gravity: 0.1
    };
  });

  renderParticles(particles, particleCanvasContext, width, height);
  setTimeout(function () {
    if (!document.body) {
      return;
    }

    document.body.removeChild(particleCanvas);
  }, 1000);
}